import React, { Component } from "react";
import ApiRequest from "../../libs/request";
import Nav from "./Nav";
import FeedNav from "./FeedNav";

function UsersList(_props) {
  if (!_props.users || _props.users.length === 0) {
    return (
      <div
        style={{
          padding: "30px",
          textAlign: "center",
          color: "#999",
          fontSize: "14px",
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
          border: "1px solid #e8e8e8",
        }}
      >
        No review requests found
      </div>
    );
  }
  let _items = [];

  _props.users.forEach((user, idx) => {
    var _display = user.status == "accepted" ? "none" : "block";
    let userProfile = user.friend;
    let userId = user.friend.id;

    if (userProfile) {
      _items.push(
        <div
          key={idx}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px",
            marginBottom: "12px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
            e.currentTarget.style.borderColor = "#ff9500";
            e.currentTarget.style.backgroundColor = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
            e.currentTarget.style.borderColor = "#e8e8e8";
            e.currentTarget.style.backgroundColor = "#f9f9f9";
          }}
        >
          {/* User Info */}
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flex: 1 }}>
            <a
              href={"/user/profile/" + userId + "#profile"}
              style={{ textDecoration: "none" }}
            >
              <img
                src={userProfile.profile_photo}
                alt="User"
                style={{
                  height: "50px",
                  width: "50px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #f0f0f0",
                  cursor: "pointer",
                }}
              />
            </a>
            <div>
              <a
                href={"/user/profile/" + userId + "#profile"}
                style={{
                  textDecoration: "none",
                  color: "#000",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  {userProfile.first_name} {userProfile.last_name}
                </p>
              </a>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {_display === "block" && (
              <button
                id={userId}
                // style={{
                //   padding: "8px 16px",
                //   backgroundColor: "#f44336",
                //   color: "white",
                //   border: "none",
                //   borderRadius: "6px",
                //   fontSize: "13px",
                //   fontWeight: "600",
                //   cursor: "pointer",
                //   whiteSpace: "nowrap",
                //   transition: "all 0.2s ease",
                // }}
                className="modern-reject-btn"
                // onMouseEnter={(e) => {
                //   e.target.style.backgroundColor = "#da190b";
                //   e.target.style.transform = "translateY(-2px)";
                // }}
                // onMouseLeave={(e) => {
                //   e.target.style.backgroundColor = "#f44336";
                //   e.target.style.transform = "translateY(0)";
                // }}
                type="button"
                onClick={() => _props.onButtonClick(userProfile)}
              >
                CANCEL
              </button>
            )}
          </div>
        </div>
      );
    }
  });

  return (
    <div
      style={{
        marginBottom: "24px",
      }}
    >
      {_items.length === 0 ? (
        <div
          style={{
            padding: "30px",
            textAlign: "center",
            color: "#999",
            fontSize: "14px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
          }}
        >
          No review requests found
        </div>
      ) : (
        _items
      )}
    </div>
  );
}

class ReviewRequests extends Component {
  constructor(props) {
    super(props);
    this.state = { friends: [], pending: [], review_user: null };
  }

  render() {
    if (this.state.review_user) {
      return this.reviewForm();
    } else {
      return this.list();
    }
  }

  reviewForm() {
    return (
      <React.Fragment>
        <Nav user={this.props.user} />
        <div className="feed">
          <div className="row  feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <h4>
                You Received A Review Request from{" "}
                {this.state.review_user.user?.first_name}{" "}
                {this.state.review_user.user?.last_name}{" "}
              </h4>
              <div className="row">
                <div className="col-3">
                  <img
                    src={this.state.review_user.user?.profile_photo.thumb.url}
                    width="100"
                    height="100"
                  />
                </div>
                <div className="col-6">
                  <form>
                    <div className="form-group">
                      <label>Rating (optional)</label>
                      <input
                        type="range"
                        id="rating"
                        onChange={this.handleSlider.bind(this)}
                        className="form-control"
                        min="1"
                        max="10"
                        step="1"
                      />
                      <span className="sliderVal">1</span>
                    </div>
                    <div className="form-group">
                      <label>Review</label>
                      <textarea
                        id="comments"
                        className="form-control"
                      ></textarea>
                    </div>
                  </form>
                  <button
                    type="button"
                    className="g-button full"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleSubmit() {
    var api = new ApiRequest("post", "/friends/review");
    api.send(
      {
        friend_id: this.state.review_user.id,
        from_user_id: this.props.user?.id,
        to_user_id: this.state.review_user.user?.id,
        rating: document.getElementById("rating").value,
        comments: document.getElementById("comments").value,
      },
      () => {
        this.setState({ review_user: null });
        this.loadData();
      }
    );
  }

  handleSlider(e) {
    let slider = document.querySelector(".sliderVal");
    slider.innerText = e.target.value;
  }

  list() {
    return (
      <React.Fragment>
        <Nav user={this.props.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  minHeight: "60vh",
                  padding: "20px",
                }}
              >
                <div
                className="mob-frnd-re-cont"
                  style={{
                    width: "100%",
                   
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "40px",
                  }}
                >
                  <h2
                    style={{
                      marginBottom: "30px",
                      fontSize: "26px",
                      fontWeight: "700",
                      color: "#000",
                      borderBottom: "2px solid #ff9500",
                      paddingBottom: "15px",
                      display: "inline-block",
                    }}
                  >
                    Review Sent Requests
                  </h2>

                  <div style={{ marginTop: "20px" }}>
                    <UsersList
                      users={this.state.friends}
                      hasAction={"block"}
                      pending={this.state.pending}
                      onButtonClick={(user) => {
                        this.hanldeAccept(user);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  hanldeAccept(user) {
    var api = new ApiRequest("post", "/user/cancel-request");
    api.send({ friend_id: user.id }, (result) => {
      
        this.loadData();
      
    });
  }

  loadData() {
    var api = new ApiRequest("get", "/user/view-requests?type=review");
    api.send({}, (result) => {
      console.log(result.data.requests)
      this.setState({ friends: result.data.requests });
    });
  }

  componentDidMount() {
    this.loadData();
  }
}
export default ReviewRequests;
